<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack" :disabled="enviando">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Bimestral AEE
        </h1>
      </v-col>
    </v-row>

    <v-row v-if="matricula">
      <v-col cols="12">
        <v-card color="green lighten-1" outlined>
          <v-card-text>
            <h4>Aluno(a): {{ matricula.aluno ? matricula.aluno.nomecompleto : "- - -" }}</h4>
            <h4>Professor(a) do AEE: {{ professoresDoAEE }}</h4>
            <h4>Turma: {{ matricula.turma ? matricula.turma.descricao : "- - -" }}</h4>
            <h4>Turno: {{ turnoDescricao }}</h4>
            <h4>Professor(a) auxiliar: {{ professoresAuxiliaresDescricao }}</h4>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12 text-center" class="p-2">
        <v-toolbar>
          <v-tabs dark v-model="tabAtual" background-color="primary" grow>
            <v-tab
              v-for="item of $constants.bimestres"
              :key="item.value"
              @click="() => trocarBimestre(item.value)"
            >
              {{ item.desc }}
            </v-tab>
          </v-tabs>
        </v-toolbar>
      </v-col>
    </v-row>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <v-card class="pa-4" rounded>
        <form @submit.prevent="handleSubmit(salvar)" :disabled="enviando">
          <!-- Identificação -->
          <e-titulo-secao-aee titulo="Identificação" />
          <v-row>
            <v-col cols="12" md="4">
              <v-dialog v-model="modalData" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Data</e-label>
                  <v-text-field
                    :value="dataFormatada"
                    label="Escolha uma data"
                    readonly
                    clearable
                    @click:clear="form.data = null"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dataSelecionada" locale="pt-BR" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelarData"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="confirmarData"> OK </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12">
              <e-label>Deficiência / TEA / Altas habilidades ou superdotação</e-label>
              <v-row dense>
                <v-col
                  class="py-0"
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="deficiencia of $constants.deficienciasAEE"
                  :key="deficiencia"
                >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="form.deficiencias"
                    :label="deficiencia"
                    :value="deficiencia"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Outra deficiência"
                v-slot="{ errors }"
                :rules="{ max_chars: 255, no_special_chars: true }"
              >
                <e-label>Outra</e-label>
                <v-text-field
                  solo
                  dense
                  v-model="form.deficiencia_outra"
                  :error-messages="errors"
                  counter="255"
                  maxlength="255"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Estudo do caso -->
          <e-titulo-secao-aee titulo="Estudo do caso" />
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                name="Mapeamento de barreiras"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>1. Mapeamento de barreiras</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.mapeamento_barreiras"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Potencialidades e interesses"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>2. Potencialidades e interesses</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.potencialidades_interesses"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Descrição da demanda"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>3. Descrição da demanda</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.descricao_demanda"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Plano de suporte e acessibilidade -->
          <e-titulo-secao-aee titulo="4. Plano de suporte e acessibilidade" />
          <v-row>
            <v-col cols="12" md="4">
              <e-label>Profissional de Apoio Escolar</e-label>
              <e-autocomplete
                :items="$constants.profissionalDeApoioEscolarAEE"
                :return-object="false"
                v-model="form.profissional_apoio_escolar"
                label="Selecione uma opção"
                clearable
                dense
                solo
              />
            </v-col>
            <v-col cols="12" md="8">
              <ValidationProvider
                name="Momentos do profissional de apoio"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>Especificar momentos</e-label>
                <v-textarea
                  rows="2"
                  solo
                  dense
                  v-model="form.profissional_apoio_momentos"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <e-label>Adaptação de Materiais</e-label>
              <v-row dense>
                <v-col
                  class="py-0"
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="material of $constants.adaptacaoDeMateriaisAEE"
                  :key="material"
                >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="form.adaptacao_materiais"
                    :label="material"
                    :value="material"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <e-label>Flexibilização Ambiental</e-label>
              <v-row dense>
                <v-col
                  class="py-0"
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="flexibilizacao of $constants.flexibilizacaoAmbientalAEE"
                  :key="flexibilizacao"
                >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="form.flexibilizacao_ambiental"
                    :label="flexibilizacao"
                    :value="flexibilizacao"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Organização do AEE -->
          <e-titulo-secao-aee titulo="Organização do Atendimento Educacional Especializado" />
          <v-row>
            <v-col cols="12" md="4">
              <e-label>Frequência do Atendimento semanal</e-label>
              <e-autocomplete
                :items="$constants.frequenciaSemanalAEE"
                :return-object="false"
                :item-value="(item) => item.value"
                :item-text="(item) => item.desc"
                v-model="form.frequencia_semanal"
                label="Selecione uma opção"
                clearable
                dense
                solo
              />
            </v-col>
            <v-col cols="12" md="4">
              <e-label>Composição do atendimento</e-label>
              <e-autocomplete
                :items="$constants.composicaoDoAtendimentoAEE"
                :return-object="false"
                v-model="form.composicao_atendimento"
                label="Selecione uma opção"
                clearable
                dense
                solo
              />
            </v-col>

            <v-col cols="12">
              <e-label>Dias e Horários do AEE</e-label>
              <v-alert v-if="!horarios.length" dense text type="warning" class="mt-2">
                Nenhum horário cadastrado para o turno desta turma AEE.
              </v-alert>
              <v-card outlined class="mt-2" v-else>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="30%">Dia</th>
                        <th class="text-left">Horário</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="dia of $constants.diasDeAtendimentoAEE" :key="dia">
                        <td>
                          <v-checkbox
                            hide-details
                            dense
                            :label="dia"
                            :input-value="diaSelecionado(dia)"
                            @change="(valor) => alternarDia(dia, valor)"
                          />
                        </td>
                        <td>
                          <e-autocomplete
                            :items="horarios"
                            :return-object="false"
                            :item-value="(item) => item.id"
                            :item-text="(item) => item.descricao"
                            :value="horarioDoDia(dia)"
                            @change="(horarioId) => definirHorarioDoDia(dia, horarioId)"
                            :disabled="!diaSelecionado(dia)"
                            label="Selecione um horário"
                            clearable
                            dense
                            solo
                            hide-details
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>

            <v-col cols="12">
              <e-label>Tipo de Atendimento</e-label>
              <v-row dense>
                <v-col
                  class="py-0"
                  cols="12"
                  md="6"
                  v-for="tipo of $constants.tiposDeAtendimentoAEE"
                  :key="tipo"
                >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="form.tipos_de_atendimento"
                    :label="tipo"
                    :value="tipo"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Plano de desenvolvimento individualizado -->
          <e-titulo-secao-aee titulo="Plano de desenvolvimento individualizado" />
          <v-row>
            <v-col cols="12">
              <e-label>Área</e-label>
              <v-row dense>
                <v-col
                  class="py-0"
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="area of $constants.areasDesenvolvimentoAEE"
                  :key="area"
                >
                  <v-checkbox hide-details dense v-model="form.areas" :label="area" :value="area" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Outras áreas"
                v-slot="{ errors }"
                :rules="{ max_chars: 255, no_special_chars: true }"
              >
                <e-label>Outras</e-label>
                <v-text-field
                  solo
                  dense
                  v-model="form.areas_outras"
                  :error-messages="errors"
                  counter="255"
                  maxlength="255"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Objetivos"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>Objetivos</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.objetivos"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Metodologia"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>Metodologia</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.metodologia"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Recursos"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <e-label>Recursos</e-label>
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.recursos"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Acompanhamento e Avaliação -->
          <e-titulo-secao-aee titulo="Acompanhamento e Avaliação" />
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                name="Acompanhamento e avaliação"
                v-slot="{ errors }"
                :rules="{ max_chars: 4000, no_special_chars: true }"
              >
                <v-textarea
                  rows="4"
                  solo
                  dense
                  v-model="form.acompanhamento_avaliacao"
                  :error-messages="errors"
                  counter="4000"
                  maxlength="4000"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mb-10">
            <v-col cols="12">
              <v-btn color="primary" :disabled="enviando" :loading="enviando" type="submit">
                {{ voltarParaAtendimento ? "Salvar e lançar atendimento" : "Salvar Plano" }}
              </v-btn>
              <v-btn
                v-if="!voltarParaAtendimento"
                class="ml-3"
                color="primary"
                outlined
                :disabled="enviando"
                @click="irParaCriacaoDeAtendimento"
              >
                Lançar atendimento
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </ValidationObserver>
  </main-template>
</template>

<script>
import ETituloSecaoAEE from "@/components/EducacaoInclusiva/ETituloSecaoAEE.vue";

export default {
  components: { "e-titulo-secao-aee": ETituloSecaoAEE },
  data() {
    return {
      enviando: false,
      tabAtual: 0,
      matricula: null,
      professoresAuxiliares: [],
      horarios: [],
      modalData: false,
      dataSelecionada: null,
      form: this.formVazio(0),
    };
  },
  watch: {
    modalData(aberto) {
      if (aberto) this.dataSelecionada = this.form.data;
    },
  },
  computed: {
    matriculaId() {
      return parseInt(this.$route.params.matricula_id, 10);
    },
    /**
     * Quem chegou aqui pelo alerta da tela de atendimento volta para lá ao salvar.
     * Quem veio da lista da turma continua no plano, para preencher os outros bimestres.
     */
    voltarParaAtendimento() {
      return this.$route.query.voltarPara === "atendimento";
    },
    bimestreInicial() {
      const bimestre = parseInt(this.$route.query.bimestre, 10);
      return Number.isInteger(bimestre) && bimestre >= 0 && bimestre <= 3 ? bimestre : 0;
    },
    dataFormatada() {
      return this.form.data ? this.form.data.split("-").reverse().join("/") : "";
    },
    turnoDescricao() {
      return this.matricula?.turma?.turno?.descricao || "- - -";
    },
    professoresDoAEE() {
      const gestoes = this.matricula?.turma?.gestao_de_aulas_a_e_e;
      if (!Array.isArray(gestoes) || !gestoes.length) return "- - -";
      const nomes = gestoes.map((gestao) => gestao?.professor?.nome).filter(Boolean);
      return nomes.length ? [...new Set(nomes)].join(", ") : "- - -";
    },
    professoresAuxiliaresDescricao() {
      if (!this.professoresAuxiliares.length) return "Sem professor auxiliar vinculado";
      return this.professoresAuxiliares.map((professor) => professor.nome).join(", ");
    },
    gestaoDeAulaAEEId() {
      const gestoes = this.matricula?.turma?.gestao_de_aulas_a_e_e;
      return Array.isArray(gestoes) && gestoes.length ? gestoes[0].id : null;
    },
  },
  async mounted() {
    this.tabAtual = this.bimestreInicial;
    await this.carregarCabecalho();
    await this.carregarPlano(this.bimestreInicial);
  },
  methods: {
    formVazio(bimestre) {
      return {
        bimestre,
        data: null,
        deficiencias: [],
        deficiencia_outra: null,
        mapeamento_barreiras: null,
        potencialidades_interesses: null,
        descricao_demanda: null,
        profissional_apoio_escolar: null,
        profissional_apoio_momentos: null,
        adaptacao_materiais: [],
        flexibilizacao_ambiental: [],
        frequencia_semanal: null,
        dias_horarios: [],
        composicao_atendimento: null,
        tipos_de_atendimento: [],
        areas: [],
        areas_outras: null,
        objetivos: null,
        metodologia: null,
        recursos: null,
        acompanhamento_avaliacao: null,
      };
    },
    async carregarCabecalho() {
      this.$loaderService.open("Carregando dados do aluno...");
      try {
        const payload = await this.$services.planosBimestraisAEEService.cabecalho(this.matriculaId);
        this.matricula = payload.matricula;
        this.professoresAuxiliares = payload.professoresAuxiliares || [];
        this.horarios = payload.horarios || [];
      } catch (error) {
        this.$handleError(error);
        this.goBack();
      }
      this.$loaderService.close();
    },
    async carregarPlano(bimestre) {
      this.$loaderService.open("Carregando plano...");
      try {
        const plano = await this.$services.planosBimestraisAEEService.plano(
          this.matriculaId,
          bimestre
        );
        this.form = plano ? this.planoParaForm(plano, bimestre) : this.formVazio(bimestre);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    planoParaForm(plano, bimestre) {
      const vazio = this.formVazio(bimestre);
      const form = {};

      Object.keys(vazio).forEach((campo) => {
        const valor = plano[campo];
        if (Array.isArray(vazio[campo])) {
          form[campo] = Array.isArray(valor) ? valor : [];
          return;
        }
        form[campo] = valor === undefined ? vazio[campo] : valor;
      });

      form.bimestre = bimestre;
      return form;
    },
    async trocarBimestre(bimestre) {
      await this.carregarPlano(bimestre);
    },
    confirmarData() {
      this.form.data = this.dataSelecionada;
      this.modalData = false;
    },
    cancelarData() {
      this.dataSelecionada = this.form.data;
      this.modalData = false;
    },
    diaSelecionado(dia) {
      return this.form.dias_horarios.some((item) => item.dia === dia);
    },
    horarioDoDia(dia) {
      const registro = this.form.dias_horarios.find((item) => item.dia === dia);
      return registro ? registro.horario_id : null;
    },
    alternarDia(dia, selecionado) {
      if (selecionado) {
        if (!this.diaSelecionado(dia)) {
          this.form.dias_horarios.push({ dia, horario_id: null });
        }
        return;
      }
      this.form.dias_horarios = this.form.dias_horarios.filter((item) => item.dia !== dia);
    },
    definirHorarioDoDia(dia, horarioId) {
      const index = this.form.dias_horarios.findIndex((item) => item.dia === dia);
      if (index === -1) return;
      this.$set(this.form.dias_horarios, index, { dia, horario_id: horarioId });
    },
    async salvar() {
      this.enviando = true;
      try {
        const plano = await this.$services.planosBimestraisAEEService.salvar(this.matriculaId, {
          ...this.form,
          gestao_de_aula_aee_id: this.gestaoDeAulaAEEId,
        });
        this.form = this.planoParaForm(plano, this.form.bimestre);
        this.$toast.success("Plano bimestral AEE salvo com sucesso!");

        if (this.voltarParaAtendimento) {
          this.irParaCriacaoDeAtendimento();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.enviando = false;
    },
    irParaCriacaoDeAtendimento() {
      this.$router.push({
        name: "educacaoInclusiva.create",
        params: { matricula_id: this.matriculaId },
        query: { bimestre: this.form.bimestre },
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
